import AsyncStorage from '@react-native-async-storage/async-storage';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

type EventStoreState = {
  homeFilter: {
    start?: string;
    end?: string;
    showMyTeams?: boolean;
    dateRangeEnabled?: boolean;
  };
  homeJumpDate?: string;
  detailFilters: Record<
    string,
    {
      start?: string;
      end?: string;
      showMyTeams?: boolean;
      dateRangeEnabled?: boolean;
    }
  >;
  detailJumpDateByEventId: Record<string, string | undefined>;
};

const initialState: EventStoreState = {
  homeFilter: {
    start: undefined,
    end: undefined,
    showMyTeams: false,
    dateRangeEnabled: false,
  },
  homeJumpDate: undefined,
  detailFilters: {},
  detailJumpDateByEventId: {},
};

const useEventStore = createWithEqualityFn<EventStoreState>()(
  persist(() => initialState, {
    name: 'useEventStore',
    storage: createJSONStorage(() => AsyncStorage),
    partialize: (state) => ({
      homeFilter: state.homeFilter,
      detailFilters: state.detailFilters,
    }),
  }),
);

export default useEventStore;
